export class QuestionRenderer {
  render(_config = {}) {
    throw new Error('You have to implement the method render!')
  }
}
